<template>
    <div id="ym_pointManagement"
         class="clr">
        <SJMLoading v-if="loadingIsShow"
                    zIndex="11"></SJMLoading>
        <!-- 页面模块 -->
        <div id="ym_pointManagement_con"
             class="clr">
            <!-- title -->
            <div class="ym_pointManagement_con_titlebox clr">
                <ul class="clr">
                    <li class="flt">
                        <i class="iconfont icon-yonghu"></i>
                    </li>
                    <li class="flt">
                        <span>{{$t('message.nowIntegral')}}:</span>
                        <b v-html="creditManagementData.PersonInfo.integral"></b>
                    </li>
                    <li class="flt">
                        <span>{{$t('message.validityPeriod')}}:</span>
                        <!-- <b v-html="creditManagementData.PersonInfo.validityPeriod.replace(/-/g, '.')"></b> -->
                        <b v-html="$moment(creditManagementData.PersonInfo.validityPeriod).format('YYYY.MM.DD')"></b>
                    </li>
                    <li class="flt"
                        @click="pointsRecordClick()">
                        <a href="javascript:;"
                           class="cs-p">{{$t('message.integralRecord')}}</a>
                    </li>
                </ul>
            </div>
            <!-- body -->
            <div class="ym_pointManagement_con_content clr">
                <!-- 产品兑换的快递信息 -->
                <div class="ym_pointsBeExchangedBox">

                </div>
                <!--领积分 -->
                <div class="ym_adoptPointBox">
                    <h3>{{$t('message.receiveIntegral')}}</h3>
                    <!-- card.length<4的结构模拟 -->
                    <div v-if="creditManagementData.receiveIntegral.length < 4"
                         class="ym_adoptPointListBox">
                        <ul>
                            <li v-for="(item, index) in creditManagementData.receiveIntegral"
                                :key="index"
                                class="flt"
                                @click="pointsAdoptItemsClick(item)">
                                <a :href="item.type === 'link' ? item.act : 'javascript:;'"
                                   :target="item.type === 'link' ? '_blank' : '_self'">
                                    <img :src="item.imgLink">
                                </a>
                            </li>
                        </ul>
                    </div>
                    <!-- card.length>=4的结构模拟 -->
                    <div v-else
                         class="ym_adoptPointSwiperBox">
                        <div class="swiper-container"
                             @mouseover="integralSwiper.stopAutoplay()"
                             @mouseout="integralSwiper.startAutoplay()">
                            <div class="swiper-wrapper">
                                <div v-for="(item, index) in creditManagementData.receiveIntegral"
                                     :key="index"
                                     class="swiper-slide"
                                     @click="pointsAdoptItemsClick(item)">
                                    <a class="swiper-slide-imgbox"
                                       :href="item.type === 'link' ? item.act : 'javascript:;'">
                                        <img :src="item.imgLink">
                                    </a>
                                </div>
                            </div>
                            <div class="swiper-button-prev iconfont icon-zuo"></div>
                            <div class="swiper-button-next iconfont icon-you1"></div>
                        </div>
                    </div>
                </div>
                <!-- 积分兑换产品列表 -->
                <div v-if="creditManagementData.integralExchange.length != 0"
                     class="ym_pointsRights"
                     data-status="">
                    <h3>{{$t('message.integralEquity')}}</h3>
                    <div class="ym_pointsRightsList clr">
                        <ul>
                            <li v-for="(item, index) in creditManagementData.integralExchange"
                                :key="index"
                                class="flt"
                                :class="{'notAllowed': item.exist === '0', 'pointer': item.exist !== '0'}"
                                :title="`${$t('message.productNameIs')}:${item.giftName},${$t('message.productIntegralIs')}:${item.giftIntegral}`">
                                <div class="ym_pointsRightsLiImgBox"
                                     :class="  item.giftId === nowExchangeGift.giftId ? 'chosen' : ''"
                                     @click="pointsExchangeClick(item)">
                                    <img :src="item.imgLink">
                                    <div class="ym_pointsRightsLiImgBox_surplus">{{$t('message.convertible')}}<b>{{item.exist}}</b>{{$t('message.item')}}</div>
                                </div>
                                <p class="ym_pointsProcuctsName">{{item.giftName}}</p>
                                <p class="ym_pointsCount">
                                    <em>{{item.giftIntegral}}</em>{{$t('message.integral')}}
                                </p>
                                <div v-if="item.exist === '0'"
                                     class="ym_pointsRightsLiImgBox_mark">{{$t('message.grabbed')}}...<br>{{$t('message.lookOther')}}~</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 弹出层模块 -->
        <el-dialog :visible.sync="computedMarkIsShow"
                   :show-close="false">
            <!-- 积分记录 -->
            <div v-show="markIsShow === 'pointsRecord'"
                 id="ym_pointsRecord">
                <span class="close"
                      @click="markIsShow = ''">
                    <i class="el-icon el-icon-close"></i>
                </span>
                <div v-if="pointsRecordLoadingIsShow"
                     class="sjmLoadingBox">
                    <SJMLoading></SJMLoading>
                </div>
                <div class="ym_pointsRecord_title">
                    <em></em>
                    <h3>{{$t('message.integralRecord')}}</h3>
                    <el-select v-model="pointMonth"
                               size="mini"
                               class="monthSelect">
                        <el-option
                                v-for="item in pointMonthList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="pointsRecordData.length != 0"
                     class="ym_pointsRecord_list">
                    <div v-for="(item, index) in pointsRecordData"
                         :key="index"
                         :class="item.addSub === '0' ? 'add' : 'reduce'">
                        <ul>
                            <!-- <li class="flt">{{item.date.replace(/-/g, '.')}}</li> -->
                            <li class="flt">{{$moment(item.date).format('YYYY.MM.DD')}}</li>
                            <li class="flt"
                                :title="item.info">{{item.info}}</li>
                            <li class="flt">
                                <span>{{item.addSub === '0' ? '+' : '-'}}</span>
                                <span>{{item.integral}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else
                     class="ym_pointsRecordNodata">
                    {{$t('message.noIntegralRecord')}}!
                </div>
            </div>
            <!-- 积分兑换确认 -->
            <div v-show="markIsShow === 'pointsConfirm'"
                 id="ym_pointsConfirm"
                 :title="`${$t('message.productNameIs')}:${nowExchangeGift.giftName},${$t('message.productIntegralIs')}:${nowExchangeGift.giftIntegral}`">
                <div class="ym_pointsConfirm">
                    <span class="close"
                          @click="pointsExchangeClose()">
                        <i class="el-icon el-icon-close"></i>
                    </span>
                    <div class="ym_pointsConfirm_imgBox">
                        <img :src="nowExchangeGift.imgLink">
                    </div>
                    <p>
                        {{$t('message.useOrNot')}}<span> {{nowExchangeGift.giftIntegral}} </span>{{$t('message.integralExchange')}}<span>{{nowExchangeGift.giftName}}</span>{{$t('message.product')}}
                    </p>
                    <div class="ym_pointsConfirmBtns">
                        <el-button size="small"
                                   type="success"
                                   @click="pointsExchangeOK()">{{$t('message.confirm')}}</el-button>
                        <el-button size="small"
                                   @click="pointsExchangeClose()">{{$t('message.cancel')}}</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        // 个人中心-账户中心-积分管理
        name: 'PointManagement',
        data () {
            return {
                // 积分管理页面数据
                creditManagementData: {
                    // 个人信息
                    PersonInfo: {
                        integral: '',// 用户当前积分
                        validityPeriod: ''// 有效期
                    },
                    // 领积分（轮播，最少一个）
                    receiveIntegral: [],
                    // 积分兑换
                    integralExchange: []
                },
                // 当前选择兑换的商品
                nowExchangeGift: {
                    giftId: 'xxx',// 礼品ID
                    giftName: 'xxx',// 礼品名称
                    giftIntegral: '0',// 礼品积分
                    imgLink: '',// 产品图
                    exist: '' // 兑换限制 大于等于0 整数
                },
                // 积分记录数据
                pointsRecordData: [],
                // 是否显示 loading
                loadingIsShow: false,
                // 是否显示弹出层
                computedMarkIsShow: false,
                // 显示哪个弹出层 ( pointsRecord / pointsConfirm )
                markIsShow: '',
                // 是否显示 积分记录 loading
                pointsRecordLoadingIsShow: false,
                // 签到天数
                signInDays: '0',
                // 积分记录月份list
                pointMonthList: [
                    {value: '3', label: this.$t('message.threeMonths')},
                    {value: '6', label: this.$t('message.halfYear')},
                    {value: '12', label: this.$t('message.oneYear')}
                ],
                // 积分记录月份
                pointMonth: '3',
                // 领积分轮播图 swiper
                integralSwiper: null,
            };
        },
        watch: {
            // 弹窗如果是这3种则显示背景
            markIsShow () {
                switch (this.markIsShow) {
                    case 'pointsRecord':
                    case 'pointsConfirm':
                        this.computedMarkIsShow = true;
                        break;
                    default:
                        this.computedMarkIsShow = false;
                        break;
                }
            },
            // 如果不是上面3种弹窗
            computedMarkIsShow () {
                if (!this.computedMarkIsShow) {
                    this.markIsShow = '';
                }
            },
            // 积分记录 切换 月份
            pointMonth () {
                // 积分记录 ajax
                this.thePointRecordAjax();
                // 大数据 个人中心-积分管理-3个月/6个月/1年
                this.$bigData(`GR+ZH+JF+JFGL+${this.pointMonth}M`, `${this.pointMonth}M`, '1');
            }
        },
        mounted () {
            // 积分管理主页页面渲染 ajax
            this.theMainDrawAjax();
        },
        methods: {
            // 弹窗关闭
            dialogCloseFn () {
                this.markIsShow = '';
            },
            // 点击 积分记录
            pointsRecordClick () {
                this.markIsShow = 'pointsRecord';
                this.markWidth = '460px';
                // 积分记录 ajax
                this.thePointRecordAjax();
                // 大数据 个人中心-积分管理-积分记录
                this.$bigData('GR+ZH+JF+JFJL', '积分记录', '1');
            },
            // 积分记录 ajax
            thePointRecordAjax () {
                this.pointsRecordLoadingIsShow = true;
                this.$ajax({
                    url: '/personalCenterHandler/accountCenter/CreditManagementHandler.ashx',
                    data: {
                        act: 'getExchangeRecordData', // 获取 积分管理 兑换积分 纪录
                        month: this.pointMonth, // 查询月份
                    },
                    success: (res) => {
                        this.pointsRecordData = res.success.Records;
                        this.pointsRecordLoadingIsShow = false;
                    }
                });
            },
            // 积分管理主页页面渲染 ajax
            theMainDrawAjax () {
                this.loadingIsShow = true;
                this.$ajax({
                    url: '/personalCenterHandler/accountCenter/CreditManagementHandler.ashx',
                    data: {
                        act: 'getCreditManagementData' // 获取积分管理页面数据
                    },
                    success: (res) => {
                        // 存积分管理页面数据
                        this.creditManagementData = res.success;
                        // 领积分项目个数 >= 4 时 初始化轮播图方法
                        this.$nextTick(() => {
                            // 领积分初始化轮播图
                            this.pointsAdoptSwiper();
                        });
                        this.loadingIsShow = false;
                    }
                });
            },
            // 领积分初始化轮播图
            pointsAdoptSwiper () {
                this.integralSwiper = new this.$swiper('.swiper-container', {
                    observer: true, // 当改变swiper的样式 或 修改swiper的子元素时 自动初始化swiper
                    slidesPerView: 4, // 同时显示个数
                    loop: true, // 无限循环
                    autoplay: 2000, // 自动播放 && 切换延迟
                    autoplayDisableOnInteraction: false, // 如果设置为false 用户操作swiper之后自动切换不会停止 每次都会重新启动autoplay
                    autoHeight: true, // 自适应内容高度
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                });
            },
            // 点击 领积分item 
            pointsAdoptItemsClick (item) {
                if (item.type === 'function') {
                    if (item.act === 'tanchuang()') {
                        // 签到 ajax
                        this.theSignInAjax();
                    }
                }
                // 大数据 个人中心-积分管理-领积分
                this.$bigData('GR+ZH+JF+LJF', '领积分', '1');
            },
            // 点击 积分兑换
            pointsExchangeClick (item) {
                // 当前选择兑换的商品
                this.nowExchangeGift = item;
                // 用户积分 - 兑换商品需要的积分
                let remainPoint = Number(this.creditManagementData.PersonInfo.integral) - Number(item.giftIntegral);
                // 剩余积分 >= 0 可以买
                if (remainPoint >= 0) {
                    this.markIsShow = 'pointsConfirm';
                } else {
                    this.$Alert({
                        msg: this.$t('message.integralInsufficient')
                    });
                }
                // 大数据 个人中心-积分管理-积分兑换
                this.$bigData('GR+ZH+JF+JFDH', '积分兑换', '1');
            },
            // 积分兑换 确认兑换
            pointsExchangeOK () {
                this.markIsShow = '';
                this.$router.push({
                    path: '/personalCenter/PersonalCenterMain/accountCenter/creditManagement/PointsExchange',
                    query: {
                        productId: this.nowExchangeGift.giftId
                    }
                });
            },
            // 积分兑换关闭弹窗
            pointsExchangeClose () {
                this.markIsShow = '';
                this.nowExchangeGift = {
                    giftId: '',// 礼品ID
                    giftName: '',// 礼品名称
                    giftIntegral: '0',// 礼品积分
                    imgLink: '',// 产品图
                    exist: '' // 兑换限制 大于等于0 整数
                };
            },
            // 签到 ajax
            theSignInAjax () {
                this.loadingIsShow = true;
                this.$ajax({
                    url: '/personalCenterHandler/accountCenter/CreditManagementHandler.ashx',
                    data: {
                        act: 'postSignInData', // 发送积分管理 签到
                    },
                    complete: () => {
                        this.loadingIsShow = false;
                    },
                    success: (res) => {
                        // 签到天数
                        this.signInDays = res.success.signInDays;
                        // 弹出签到成功弹窗
                        this.$Alert({
                            msg: `<h3>${ Number(this.signInDays) % 7 === 0 ? `${this.$t('message.integral')}+1` : '' }</h3>
                            <p>${ this.$t('message.checkedIn') }<span style="color: #1EAA39;font-size: 24px;"> ${this.signInDays} </span>${this.$t('message.day')} &nbsp;<span>${this.$t('message.keepItUp')}~</span>`,
                            title: '签到成功',
                            type: 'success',
                            dangerouslyUseHTMLString: true,
                        });
                        // 重载登录状态
                        this.$isLogin();
                    }
                });
            }
        }
    };
</script>
<style lang="scss" scoped>
    .notAllowed {
        cursor: not-allowed;
    }

    .pointer {
        cursor: pointer;
    }

    #ym_pointManagement {
        position: relative;
        width: 1070px;
        min-height: 732px;
        overflow: hidden;
        background-color: #f4f4f4;
    }

    #ym_pointManagement #ym_pointManagement_con {
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    #ym_pointManagement .flt > b {
        margin-left: 4px;
    }

    /* 头部css */

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox {
        width: 100%;
        height: 52px;
        margin-bottom: 20px;
        background-color: #fff;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul {
        width: 100%;
        height: 52px;
        padding-left: 34px;
        line-height: 52px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(1) i {
        margin-right: 25px;
        font-size: 38px;
        font-weight: 700;
        color: #0094dd;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(2) {
        margin-right: 37px;
        line-height: 52px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(2) span {
        font-size: 16px;
        color: #595757;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(2) b {
        font-size: 20px;
        color: #e73828;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(3) {
        margin-right: 41px;
        line-height: 52px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(3) span {
        font-size: 16px;
        color: #595757;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(3) b {
        font-size: 20px;
        color: #e73828;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(4) {
        line-height: 52px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_titlebox ul li:nth-child(4) a {
        font-size: 16px;
        color: #009fe8;
    }

    /* 身体部分 */

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_content {
        width: 1070px;
        min-height: 661px;
        overflow: hidden;
        background-color: #fff;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_content .ym_pointsBeExchangedBox {
        display: none;
        width: 100%;
        margin-bottom: 25px;
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_content .ym_pointsBeExchangedBox.hidden {
        display: none;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_content .ym_pointsBeExchangedBox p {
        height: 40px;
        padding-left: 34px;
        overflow: hidden;
        line-height: 40px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_content .ym_pointsBeExchangedBox p span.ym_pointsBeExchangedBox_txt {
        font-size: 16px;
        color: #595757;
    }

    #ym_pointManagement .ym_pointsBeExchangedBox_txt b.red {
        color: #e73828;
    }

    #ym_pointManagement .ym_pointsBeExchangedBox_txt a.blue {
        color: #009fe8;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_content .ym_adoptPointBox {
        margin-top: 21px;
        margin-bottom: 55px;
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointManagement_con_content .ym_adoptPointBox h3 {
        padding-left: 35px;
        margin-bottom: 9px;
        font-size: 20px;
        color: #3e3a39;
    }

    /* 领积分<4个卡片的样式 */

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointListBox {
        height: 114px;
        margin-left: 34px;

        /* display: none; */
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointListBox ul {
        height: 114px;
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointListBox ul li {
        height: 114px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointListBox ul li a {
        display: block;
        width: 202px;
        height: 114px;
        margin-right: 28px;

        /* background-color: #E73828; */
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointListBox ul li a img {
        width: 100%;
    }

    /* 领积分>=4个卡片的样式 即轮播样式 */

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox {
        position: relative;
        width: 958px;
        height: 113px;
        margin-left: 34px;
        text-align: center;
    }

    .swiper-button-next,
    .swiper-button-prev {
        background: none;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox .swiper-container {
        position: static;
        display: inline-block;
        width: 920px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox .swiper-slide {
        width: 230px !important;
        height: 114px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox .swiper-slide .swiper-slide-imgbox {
        display: block;
        width: 202px;
        height: 114px;
        margin-right: 28px;
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox .swiper-slide .swiper-slide-imgbox img {
        width: 100%;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox .swiper-wrapper {
        position: static;
        height: 114px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox .swiper-button-prev {
        position: absolute;
        left: -10px;
        font-size: 20px;
        line-height: 44px;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_adoptPointBox .ym_adoptPointSwiperBox .swiper-button-next {
        position: absolute;
        right: 17px;
        font-size: 20px;
        line-height: 44px;
    }

    /* 积分权益 */

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRights {
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRights h3 {
        padding-left: 35px;
        margin-bottom: 12px;
        font-size: 20px;
        color: #3e3a39;
    }

    /* 积分权益盒子 */

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList {
        min-height: 400px;
        padding-left: 35px;
        margin-bottom: 10px;
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul {
        overflow: hidden;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li {
        position: relative;
        width: 169px;
        height: 170px;
        margin-right: 84px;
        margin-bottom: 20px;
        text-align: center;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li .ym_pointsRightsLiImgBox.chosen {
        border: 1px solid #2ca6e0;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li .ym_pointsRightsLiImgBox {
        position: relative;
        width: 100%;
        height: 120px;
        margin-bottom: 3px;

        /* background-color: #E73828; */
        overflow: hidden;
        border: 1px solid rgba(35, 24, 21, 0.3);
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li .ym_pointsRightsLiImgBox img {
        width: 100%;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li p.ym_pointsProcuctsName {
        width: 100%;
        overflow: hidden;
        font-size: 15px;
        color: #595757;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li p.ym_pointsCount {
        width: 100%;
        overflow: hidden;
        font-size: 15px;
        font-weight: 500;
        color: #f29600;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li p.ym_pointsCount em {
        font-style: normal;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li .ym_pointsRightsLiImgBox_mark {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 171px;
        height: 91px;
        padding-top: 30px;
        font-size: 16px;
        line-height: 30px;
        color: #fff;
        text-align: center;
        cursor: not-allowed;
        background-color: rgba(0, 0, 0, 0.4);
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li .ym_pointsRightsLiImgBox_surplus {
        position: absolute;
        top: 120px;
        left: 0;
        width: 100%;
        height: 24px;
        line-height: 24px;
        color: #fff;
        text-align: center;
        background-color: rgba(0, 0, 0, 0.3);
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li .ym_pointsRightsLiImgBox:hover .ym_pointsRightsLiImgBox_surplus {
        -webkit-animation: mymove 500ms;
        animation: mymove 500ms;
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
    }

    #ym_pointManagement #ym_pointManagement_con .ym_pointsRightsList ul li .ym_pointsRightsLiImgBox_surplus b {
        color: #e73828;
    }

    /* 积分权益hover动画 */
    @keyframes mymove {
        from { top: 120px; }

        to {
            top: 96px;
        }
    }

    /* Safari 和 Chrome: */
    @-webkit-keyframes mymove {
        from {
            top: 120px;
        }

        to {
            top: 96px;
        }
    }


    /* 遮罩层样式 */
    #ym_mark {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 99999;
        width: 1070px;
        height: 783px;
        background-color: rgba(0, 0, 0, 0.4);
    }

    #ym_pointsRecord {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 460px;
        height: 590px;
        margin-top: -295px;
        margin-left: -230px;
        background-color: #fff;
        border: 1px #717071 solid;
        border-radius: 10px;
    }

    #ym_pointsRecord .ym_pointsRecord_title {
        position: relative;
        height: 32px;
        padding-top: 23px;
        padding-left: 32px;
        margin-bottom: 15px;
        line-height: 32px;
    }

    #ym_pointsRecord .ym_pointsRecord_title em {
        display: inline-block;
        float: left;
        width: 3px;
        height: 100%;
        margin-right: 13px;
        background-color: #009fe8;
    }

    #ym_pointsRecord .ym_pointsRecord_title h3 {
        float: left;
        font-size: 22px;
        color: #009fe8;
    }

    #ym_pointsRecord .ym_pointsRecord_title .monthSelect {
        float: right;
        width: 135px;
        margin-right: 28px;
    }

    .sjmLoadingBox {
        position: absolute;
        width: 100%;
        height: calc(100% - 20px);
        margin-top: 10px;
    }

    /deep/ .el-dialog,
    /deep/ .el-dialog__body {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0 !important;
        background: transparent;
    }

    /deep/ .el-dialog__header {
        display: none;
    }

    .close {
        position: absolute;
        top: -10px;
        right: -12px;
        z-index: 4;
        display: inline-block;
        width: 28px;
        height: 28px;
        font-size: 22px;
        line-height: 28px;
        color: rgba(113, 112, 113, 1);
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        background: #fff;
        border: 1px solid rgba(113, 112, 113, 1);
        border-radius: 50%;
    }

    #ym_pointsRecord .ym_pointsRecord_list {
        height: 510px;
        padding-left: 30px;
        overflow-y: scroll;
    }

    .ym_pointsRecordNodata {
        height: 40px;
        margin-top: 130px;
        font-size: 30px;
        font-weight: 500;
        text-align: center;
    }

    #ym_pointsRecord .ym_pointsRecord_list div ul li:nth-child(3) {
        /* width: 50px; */
    }

    #ym_pointsRecord .ym_pointsRecord_list div ul li:nth-child(3) span:nth-child(1) {
        display: block;
        float: left;
        width: 20px;
        text-align: center;
    }

    #ym_pointsRecord .ym_pointsRecord_list div.add ul li:nth-child(3) span {
        color: #8dc21f;
    }

    #ym_pointsRecord .ym_pointsRecord_list div.reduce ul li:nth-child(3) span {
        color: #e73828;
    }

    #ym_pointsRecord .ym_pointsRecord_list div {
        margin-bottom: 15px;
        overflow: hidden;
    }

    #ym_pointsRecord .ym_pointsRecord_list div ul {
        overflow: hidden;
    }

    #ym_pointsRecord .ym_pointsRecord_list div ul li {
        font-size: 15px;
        color: #595757;
    }

    #ym_pointsRecord .ym_pointsRecord_list div ul li span {
        font-size: 15px;
    }

    #ym_pointsRecord .ym_pointsRecord_list div ul li:nth-child(1) {
        margin-right: 39px;
    }

    #ym_pointsRecord .ym_pointsRecord_list div ul li:nth-child(2) {
        width: 140px;
        margin-right: 58px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    #ym_signInSuccess {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 334px;
        height: 208px;
        margin: auto;
        background-image: url('/img/personalCenter/accountCenter/creditManagement/signInSuccessBg.png');
        border-radius: 10px;
    }

    #ym_signInSuccess .ym_signInSuccess {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
    }

    #ym_signInSuccess .ym_signInSuccess #signInClose {
        position: absolute;
        top: -8px;
        right: -11px;
        width: 30px;
        height: 30px;
        font-size: 30px;
        line-height: 24px;
        text-align: center;
        cursor: pointer;
        background-color: #fff;
        border: 1px solid rgba(113, 112, 113, 1);
        border-radius: 50%;
    }

    #ym_signInSuccess #signInClose .iconfont {
        margin: 0 auto;
        margin-top: 0;
        font-size: 22px;
        color: rgba(113, 112, 113, 1);
    }

    #ym_signInSuccess .iconfont {
        display: inline-block;
        margin-top: 13px;
        margin-bottom: 12px;
        font-size: 50px;

        /* width: 64px;
        height: 64px; */
        color: #1eaa39;
    }

    #ym_signInSuccess .ym_signInSuccess h3 {
        margin-bottom: 28px;
        font-size: 34px;
        color: #1eaa39;
    }

    #ym_signInSuccess .ym_signInSuccess p {
        font-size: 20px;
        color: #d76800;
    }

    #ym_signInSuccess .ym_signInSuccess p span:nth-child(1) {
        font-size: 24px;
        color: #1eaa39;
    }

    #ym_pointsConfirm {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        width: 332px;
        height: 208px;
        margin: auto;
        background-color: rgba(242, 248, 255, 0.95);
        border-radius: 10px;
    }

    #ym_pointsConfirm .ym_pointsConfirm {
        position: relative;
        width: 100%;
        height: 100%;
        text-align: center;
    }

    #ym_pointsConfirm .ym_pointsConfirm #exchangedClose {
        position: absolute;
        top: -12px;
        right: -12px;
        width: 28px;
        height: 28px;
        font-size: 30px;
        line-height: 23px;
        color: rgba(113, 112, 113, 1);
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        background-color: #fff;
        border: 1px solid rgba(113, 112, 113, 1);
        border-radius: 50%;
    }

    #exchangedClose i {
        font-size: 22px;
    }

    #ym_pointsConfirm .ym_pointsConfirm .ym_pointsConfirm_imgBox {
        display: inline-block;
        width: 98px;
        height: 98px;

        /* background-color: #E73828; */
        margin-top: 12px;
        margin-bottom: 10px;
        overflow: hidden;
    }

    #ym_pointsConfirm .ym_pointsConfirm .ym_pointsConfirm_imgBox img {
        width: 100%;
    }

    #ym_pointsConfirm .ym_pointsConfirm p {
        width: 96%;
        padding-right: 2%;
        padding-left: 2%;
        margin-bottom: 15px;
        overflow: hidden;
        font-size: 17px;
        color: #717071;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    #ym_pointsConfirm .ym_pointsConfirm p span:nth-child(1) {
        color: #e73828;
    }

    #ym_pointsConfirm .ym_pointsConfirmBtns span {
        display: inline-block;
        font-size: 16px;
        cursor: pointer;
    }

    #ym_pointsConfirm .ym_pointsConfirmBtns span:nth-child(1) {
        width: 56px;
        height: 28px;
        margin-right: 20px;
        line-height: 28px;
        color: #fff;
        text-align: center;
        background-color: #009fe8;
        border-radius: 5px;
    }

    #ym_pointsConfirm .ym_pointsConfirmBtns span:nth-child(2) {
        width: 56px;
        height: 28px;
        line-height: 28px;
        color: #717071;
        text-align: center;
    }
</style>
